export const REVISION_LOAD = 'Load revisions'
export const REVISION_LOAD_INITIAL = 'Load initial revisions'
export const REVISION_LOAD_MORE = 'Load more revisions'
export const REVISION_NEW_SET = 'Clear revisions for new entry'
export const REVISION_ADD = 'Add revisions'
export const REVISION_VIEW = 'View revision'
export const REVISION_RESTORE = 'REVISION_RESTORE'
